import React, { useEffect, useState } from 'react'
import { Select } from 'antd'

import { TrackingAnalytics } from '../../analytics/TrackingAnalytics'
import { Input } from 'src/components/shared'

import { tabFilters } from '../newDashboardUtils'

const { Option } = Select

const TabsAndSearch = ({
  defaultFilters,
  updateEvents,
  onChange: propsOnChange,
}) => {
  const [selectedFilters, setSelectedFilters] = useState({})
  const [mobileFiltersExpanded, setMobileFiltersExpanded] = useState(false)
  const [mobileSearchExpanded, setMobileSearchExpanded] = useState(false)

  // const [sortBy, setSortBy] = useState(lambda)

  // const onSort = (option) => {
  //   setSortBy(option.lambda)
  //   updateEvents(selectedFilters, option.lambda)
  // }
  const [searchValue, setSearchValue] = useState('')
  const byName = (a, target) =>
    a.name &&
    a.name.toLocaleLowerCase().includes(target.value.toLocaleLowerCase())
  const byTitle = (a, target) =>
    a.title &&
    a.title.toLocaleLowerCase().includes(target.value.toLocaleLowerCase())

  const onChange = ({ target }) => {
    setSearchValue(target.value)

    const lambda = (a) => byName(a, target) || byTitle(a, target)
    if (propsOnChange) propsOnChange({ search: { lambda } })
  }

  const onFilter = (filter) => {
    const newFilters = { ...selectedFilters, ...filter }
    setSelectedFilters(newFilters)
    updateEvents(newFilters /*, sortBy*/)
    console.log('newFilters', newFilters)
    TrackingAnalytics.send(`Dashboard - Filter changed`)
  }

  useEffect(() => {
    onFilter(defaultFilters)
    // eslint-disable-next-line
  }, [])

  return (
    <div className="tabs_toggle">
      <div className="filters_wrapper">
        <div className="desktop_filters">
          {tabFilters.map(({ id, label, options }) => (
            <div key={id} className="filter">
              <label className="filter_label">{label}</label>
              <Select
                defaultValue={(defaultFilters[id] || options[0]).value}
                onChange={(optionId) =>
                  onFilter({
                    [id]: options.filter((o) => o.id === optionId)[0],
                  })
                }
                style={{ width: 160 }}
              >
                {options.map((option) => (
                  <Option key={option.id} value={option.id}>
                    {option.text}
                  </Option>
                ))}
              </Select>
            </div>
          ))}
        </div>
        <div className="mobile_filters">
          <div
            className="expand_filters_toggle"
            onClick={() => setMobileFiltersExpanded(!mobileFiltersExpanded)}
          >
            <span>Filters</span>
            <i className="material-icons m-auto search-icon">tune</i>
          </div>
          <div className="filters">
            {mobileFiltersExpanded &&
              tabFilters.map(({ id, label, options }) => (
                <div key={id} className="filter">
                  <label className="filter_label">{label}</label>
                  <Select
                    defaultValue={(defaultFilters[id] || options[0]).value}
                    onChange={(optionId) =>
                      onFilter({
                        [id]: options.filter((o) => o.id === optionId)[0],
                      })
                    }
                    style={{ width: 160 }}
                  >
                    {options.map((option) => (
                      <Option key={option.id} value={option.id}>
                        {option.text}
                      </Option>
                    ))}
                  </Select>
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="input_wrapper search">
        <Input
          style={mobileSearchExpanded ? { width: '100%' } : {}}
          placeholder={'Search Popins'}
          onChange={onChange}
          value={searchValue}
          formControl={false}
        />
        <i
          className="material-icons m-auto search-icon"
          onClick={() => setMobileSearchExpanded(!mobileSearchExpanded)}
        >
          search
        </i>
      </div>
    </div>
  )
}

export default TabsAndSearch